
import BookingData                          from './BookingData';

/* 
 * React custom hook to manage the booking state. Includes the state management
 * although most is still managed within the booking component itself.
 * This module attempts to control the flow of data between the app core and
 * the booking components (including sidebar) in an optimal way.
 */

const BS_STATES = {
    BS_FIND_CASE:                       'find_case',
    BS_PATIENT_FOUND:                   'patient_found',
    BS_SELECT_APP_TYPE:                 'select_app_type',
    BS_SELECT_TIME:                     'select_time',
    BS_RESCHEDULE_CONFIRM:              'reschedule_confirm',
    BS_RESCHEDULE_SELECT_TIME:          'reschedule_select_time',
    BS_RESCHEDULE_SUMMARY:              'reschedule_summary',
    BS_ADD_DESCRIPTION:                 'add_description',
    BS_CAPTURE_DESCRIPTION:             'capture_description',
    BS_DESCRIPTION_CHANGE_SUMMARY:      'description_change_summary',
    BS_CONFIRM:                         'confirm',
    BS_SUMMARY:                         'summary',
    BS_DELETE_CONFIRM:                  'delete_confim',     
    BS_DELETED:                         'deleted',
    BS_CAPTURE_APPT_TIME_REASON:        'capture_appt_time_reason',                
}

const B_ACTIONS = {
    CANCEL:                 'cancel',
    BOOKING_FINALIZED:      'booking_finailized',
    FINISHED:               'finished',
    MENU_TASK_CLICK:        'menu_task_click',
    MENU_CLICK:             'menu_click',
    CANCEL_CONFIRM:         'cancelConfirm',
    PATIENT_DATA:           'PatientData',
    PATIENT_CONFIRM:        'patientConfirm',
    NEW_URL_CASE_ERROR:     'new _url_case_error',
    APPOINTMENT_TYPE:       'AppointmentType',
    // provisional booking held
    TIME_HELD_EVENT:        'TimeHeldEvent',
    PERSONAL_TIME:          'personTime',
    PERSON:                 'person', // clinician change
    DESCRIPTION_EDIT:       'description_edit',
    DESCRIPTION:            'description',
    RESCHEDULE:             'reschedule',
    DELETE:                 'delete',
    LOAD_SLOTS:             'Load_slots',
    APPT_TIME_REASON:       'appt_time_reason',
    VISUAL_CALL:            'visual_call',
}

const rescheduleStates =   [BS_STATES.BS_RESCHEDULE_CONFIRM, 
                            BS_STATES.BS_RESCHEDULE_SELECT_TIME]

const getBookingState = applicationState => {
    
    const  { booking: bookingState = {} } = applicationState
    return bookingState
}

/** Function that takes  */
const bookingReducer = ( bookingState, actionKey, actionValue = {}, eventDispatch ) => {
    
    if(actionKey && actionKey.preventDefault){
        actionKey.preventDefault()
    }
    let action;
    if( !actionValue ){
        action = actionKey;
    }else{
        action = {}
        action[ actionKey ] = actionValue;
    }
    const { target: { value: targetValue = null } = {} } = actionKey;
    
    let newState  = { ...bookingState };
    newState.warning = null;
    newState.newBooking         = new BookingData( newState.newBooking ); // in case there is no existing
    //newState.existingBooking    = new BookingData( newState.existingBooking );

    newState.lastAction = { key: actionKey, value: actionValue };
    
    switch (actionKey){
        case B_ACTIONS.CANCEL:
            if([BS_STATES.BS_FIND_CASE, BS_STATES.BS_PATIENT_FOUND].includes( newState.pageState )){
                if( !newState.newBooking.confirmed && newState.newBooking.bookingID ){
                        newState.api.deleteBooking( newState.newBooking.bookingID )
                    .then( eventDispatch( { booking: { pageState: null },
                         clear: true } ) )
                    .catch( e => eventDispatch( { booking: { pageState: null },
                         clear: true } ));
                }else{
                    eventDispatch( { booking: { pageState: null },
                             clear: true } );
                 }
                return;
            }
            break;
        case B_ACTIONS.CANCEL_CONFIRM:
            if( !newState.newBooking.confirmed && newState.newBooking.bookingID ){
                newState.api.deleteBooking( newState.newBooking.bookingID )
                .catch( e => console.log('Problem deleting a booking') );
            }
            if( BS_STATES.BS_SUMMARY === newState.pageState || 
                    BS_STATES.BS_RESCHEDULE_SUMMARY === newState.pageState ){
                
                const { clinician: { teams } = {}, start  } = newState.newBooking;
                
                if( teams.length ){
                    /* signal to the team calendar the team and date to go to */
                    eventDispatch( { team:    { teamID: teams[0], date: start },
                                    booking: { pageState: null },
                                        clear: true } ); 
                }else{
                    eventDispatch( { booking: { pageState: null },
                            clear: true } );
                }
                
            }else{
                // clear everything from this booking
               eventDispatch( { booking: { pageState: null },
                            clear: true } );
            }
            return;
        case B_ACTIONS.PATIENT_DATA:
            if(newState.newBooking.hasPatientData()){
                throw new Error("Cannot change patient");
            }
            newState.newBooking.setPatientData( action.PatientData );
            newState.pageState   = 'patient_found';
            eventDispatch( { booking: newState } );
            return;
        case B_ACTIONS.TIME_HELD_EVENT:
        
            
            
            if( newState.newBooking.isRescheduling() ){
                newState.holdBooking = new BookingData();
                newState.holdBooking.loadFromAPI( actionValue );
                newState.newBooking.setRescheduleID( actionValue.BookingID )
                newState.pageState   = BS_STATES.BS_RESCHEDULE_CONFIRM;
            }else{
                
                newState.newBooking.loadFromAPI( actionValue );
                if( !newState.newBooking.hasPatientData() ){
                    newState.pageState   = BS_STATES.BS_FIND_CASE;
                }else if (!newState.newBooking.hasDescription()) {
                    newState.pageState   = BS_STATES.BS_CAPTURE_DESCRIPTION;
                }else{
                    newState.pageState   = BS_STATES.BS_CONFIRM;
                }
            }
            eventDispatch( { booking: newState } );
            return;
        case B_ACTIONS.PERSONAL_TIME: 
            
            if( newState.newBooking.isRescheduling() ){
                
                if( Array.isArray( actionValue.availableAppTypes ) && 
                !actionValue.availableAppTypes.includes( newState.newBooking.getAppoinmnetTypeID() ) ){
                    newState.warning     = 'Clinician \'' + actionValue.partyName + '\' is not available for your chosen appointment type';
                }
            }else{
                if(!newState.newBooking.hasPatientData()){
                    newState.pageState   = 'find_case';
                }else if (newState.newBooking.hasPatientConfirmed()){
                    newState.pageState   = BS_STATES.BS_PATIENT_FOUND;
                }
                newState.newBooking.availableAppTypes = actionValue.availableAppTypes;
                newState.newBooking = 
                    getAppointmentTimeDate( newState.newBooking, 
                                            actionValue );
                if( newState.newBooking.bookingID ){
                    newState.pageState   = BS_STATES.BS_CAPTURE_DESCRIPTION;
                }
                if( Array.isArray( actionValue.availableAppTypes ) && 
                    newState.newBooking.hasAppoinmnetType() &&
                    !actionValue.availableAppTypes.includes( newState.newBooking.getAppoinmnetTypeID() ) ){
                    newState.warning     = 'The clinician is not available for your chosen appointment type';
                }else{

                }
            }
            eventDispatch( { booking: newState } );
            return;
        
        case B_ACTIONS.BOOKING_FINALIZED:
            newState.newBooking = new BookingData();
            newState.newBooking.loadFromAPI( actionValue );
            
            newState.pageState   = BS_STATES.BS_SUMMARY;
            eventDispatch( { booking: newState } );
            return;
        case B_ACTIONS.LOAD_SLOTS:
            /* No booking in progress means there is nothing to record the
             * earliest offered slot against, e.g. the availability calendar
             * viewed outside the booking flow. */
            if( bookingState.newBooking &&
                    (!bookingState.newBooking.earliestDateTimeOffered || bookingState.newBooking.earliestDateTimeOffered > actionValue) ){
                bookingState.newBooking.earliestDateTimeOffered = actionValue;
            }
            return;
        default:
    }
    
    switch ( newState.pageState ){
        case BS_STATES.BS_FIND_CASE:
            // start. Ask for case ID
            if( B_ACTIONS.CANCEL === actionKey ){
                newState.pageState   = 'find_case'
                newState.newBooking.patientData = null
            }
//            if( B_ACTIONS.PATIENT_DATA === actionKey ){
//                newState.newBooking.setPatientData( action.PatientData );
//                newState.pageState   = 'patient_found';
//            }
        break
        case 'patient_found':
            // Confirm that the patient retreived is correct
            if( action.cancel ){
                newState.pageState   = 'find_case'
                newState.newBooking  = null
            }
            if( B_ACTIONS.PERSONAL_TIME === actionKey ){
                newState.pageState   = 'select_app_type';
                newState.newBooking.setData( { PatientData: action.PatientData } )
            }
            if( B_ACTIONS.PATIENT_CONFIRM === actionKey ){
                 if( newState.newBooking.start ){
                    if( newState.newBooking.hasAppoinmnetType() ){
                        // we already have a time so go direct to confirm
                        newState.pageState   = BS_STATES.BS_CAPTURE_DESCRIPTION;
                    }else{
                        newState.pageState   = BS_STATES.BS_SELECT_APP_TYPE
                    }

                }else{
                    if( newState.newBooking.hasAppoinmnetType() ){
                        // we already have a time so go direct to confirm
                        newState.pageState   = BS_STATES.BS_STATES.BS_SELECT_TIME;
                    }else{
                        newState.pageState   = BS_STATES.BS_SELECT_APP_TYPE
                    }
                }
            }
            break;
        case BS_STATES.BS_SELECT_APP_TYPE:
            // Ask for an appointment type
            if('cancel' === targetValue){
                newState.pageState   = 'find_case'
                newState.newBooking  = null
            }
            if( B_ACTIONS.APPOINTMENT_TYPE === actionKey ){

                newState.newBooking.setData(actionValue);
                newState.newBooking.earliestDateTimeOffered = null;
                if( newState.newBooking.start ){
                    // we already have a time so go direct to confirm
                    newState.pageState   = BS_STATES.BS_CAPTURE_DESCRIPTION
                }else{
                    // appointment type received. Move on to select time
                    newState.pageState   = BS_STATES.BS_SELECT_TIME;
                }
            }
            break
        case BS_STATES.BS_RESCHEDULE_SELECT_TIME:
        // User selects a time period or an entry in a team calendar
            if( B_ACTIONS.SELECTED_TIME_EVENT === actionKey ){
                newState.pageState          = BS_STATES.BS_RESCHEDULE_CONFIRM

                newState.newBooking = 
                        getAppointmentTimeDate( newState.newBooking, 
                                                actionValue )

            } else if (B_ACTIONS.PERSON === actionKey) {
                newState.newBooking.clinician = {
                    partyID: actionValue
                }
                eventDispatch( { 
                    appType: { appointmentTypeID: newState.newBooking.getAppoinmnetTypeID() },
                    booking: newState } );
                return;
            } else if (B_ACTIONS.VISUAL_CALL === actionKey) {
                newState.newBooking.isVisual = (true === actionValue);
            }
            break
        case BS_STATES.BS_SELECT_TIME:
            // User selects a time period or an entry in a team calendar
            if( B_ACTIONS.SELECTED_TIME_EVENT === actionKey ){
                newState.pageState          = BS_STATES.BS_CAPTURE_DESCRIPTION

                newState.newBooking = 
                        getAppointmentTimeDate( newState.newBooking, 
                                                actionValue )

            }
            break

        case BS_STATES.BS_ADD_DESCRIPTION:

                if(B_ACTIONS.FINISHED === actionKey){

                    newState.pageState              = BS_STATES.BS_DESCRIPTION_CHANGE_SUMMARY;
                    newState.newBooking.description = actionValue;
                }

            break;

        case BS_STATES.BS_CAPTURE_DESCRIPTION:

                if(B_ACTIONS.DESCRIPTION === actionKey){
                    if(newState.newBooking.isApptWithin5Days){
                        newState.pageState              = BS_STATES.BS_CONFIRM;
                    }else{
                        newState.pageState              = BS_STATES.BS_CAPTURE_APPT_TIME_REASON;
                    }
                    newState.newBooking.description = actionValue;
                }

            break;
        case BS_STATES.BS_CAPTURE_APPT_TIME_REASON:

                if(B_ACTIONS.APPT_TIME_REASON === actionKey){

                    newState.pageState                      = BS_STATES.BS_CONFIRM;
                    newState.newBooking.apptTimeExplanation = actionValue ?? '';
                }

            break;
        case BS_STATES.BS_CONFIRM:
            if( B_ACTIONS.FINISHED === actionKey ){
                newState.pageState   = 'summary';
            }
            break

        case BS_STATES.BS_RESCHEDULE_CONFIRM:
            if( B_ACTIONS.FINISHED === actionKey ){
                newState.pageState   = BS_STATES.BS_RESCHEDULE_SUMMARY
                newState.newBooking = new BookingData();
                newState.newBooking.loadFromAPI( actionValue );
            }
            break

        default:
            if( B_ACTIONS.SELECTED_TIME_EVENT === actionKey ){
                newState.pageState   = 'find_case'

                newState.newBooking = 
                        getAppointmentTimeDate( newState.newBooking, 
                                                actionValue )
            }
            if( B_ACTIONS.PERSONAL_TIME === actionKey ){
                 newState.pageState   = 'find_case'
                 newState.availableAppTypes = actionValue.availableAppTypes;
                 newState.newBooking = 
                        getAppointmentTimeDate( newState.newBooking, 
                                                actionValue )
            }
            if(B_ACTIONS.RESCHEDULE === actionKey ){
                const newBooking = new BookingData();
                newBooking.loadFromAPI( actionValue );
                newBooking.setRescheduling(true);
                eventDispatch( { booking: { ...newState, newBooking: newBooking, pageState: BS_STATES.BS_RESCHEDULE_SELECT_TIME },
                                 appType: { appointmentTypeID: action.reschedule.getAppoinmnetTypeID() },
                                 menu: 'booking'} )
                return
            }
            if(B_ACTIONS.DESCRIPTION_EDIT === actionKey ){
                eventDispatch( { booking: { ...newState, newBooking: actionValue, pageState: BS_STATES.BS_ADD_DESCRIPTION },
                                 menu: 'booking'} )
                return
            }
            if(B_ACTIONS.DELETE === actionKey){
                eventDispatch( { booking: { newBooking: actionValue, 
                        pageState: BS_STATES.BS_DELETE_CONFIRM } } )
                return
            }
            if(B_ACTIONS.PATIENT_DATA === actionKey){
                newState.newBooking.setPatientData( actionValue )
                newState.pageState   = BS_STATES.BS_PATIENT_FOUND
                eventDispatch( { booking: newState, menu: 'booking'} )
                return
            }

    }
    if( B_ACTIONS.MENU_CLICK === actionKey ){
        newState.pageState   = 'find_case'
    }
    if( action.appTime ){
        newState.pageState   = 'confirm'
    }

    eventDispatch( { booking: newState } );
}
               
/* extract data about clinician and from a time / slot object.  */
const getAppointmentTimeDate = ( destBooking, actionValue ) => {
               
    let result = new BookingData( destBooking )
    
    result.setData( actionValue )
    
    return result
}

/* Similar to the useState hook in react except that we pass an event function
 * which is the one from the main application. This creates a chain of state
 * modifying functions, with state stored in the main app but also managed in 
 * the booking system. */
const useBookingState = (state, eventDispatch, api) => {
    
    if( !state.api ){
        throw new Error('API is not defined');
    }
    
    const bookingState      = getBookingState( state );
    const updater           = (actionKey, actionValue = {}) => {
        bookingState.api    = state.api;
        bookingReducer( bookingState, actionKey, actionValue, eventDispatch );
    }
    
    return [bookingState, updater];
}

const bookingInProgress = (bookingState) => {
    
    const { pageState = null }              = bookingState
    
    return (pageState && !rescheduleInProgress(bookingState) )? true: false
}

const rescheduleInProgress = (bookingState) => {
    
    const { pageState = null }              = bookingState
    
    return (pageState && rescheduleStates.includes( pageState ) )? true: false
}

/**
 * 
 * @param {type} bookingState The booking state from useBookingState
 * @returns {Boolean} exactly the same as bookingInProgress || rescheduleInProgress
 */
const bookingActive = (bookingState) => {
    
    const { pageState = null }          = bookingState
    
    return (pageState)? true: false
}

const personCalendarClick = ( api, bookingState, bookingUpdater, partyID, start, end ) => {
    
    const getName = person => {
        let name = person.PersonalTitle? person.PersonalTitle: '';
        name += person.FirstName? ( ' ' + person.FirstName): '';
        name += person.LastName? ( ' ' + person.LastName ): '';
        return name.trim();
    }
    
    const clinicianLookupAndContinue = availableAppTypes  => 
        api.getPersonDetails(partyID)
        .then( r => r.apiResult[0] )
        .then( r =>  bookingUpdater( B_ACTIONS.PERSONAL_TIME, { start, end, partyID, partyName: getName( r ) ,availableAppTypes } ) )
        .catch( err => console.log( err.message ) );
    
    const getTypesAndContinue = () => api.GetPartyTimeAppointmentTypeList( partyID, start, end )
    .then( r => r.apiResult )
    .then( r => clinicianLookupAndContinue( r ) )
    .catch( err => console.log( "err", err.message ) );
    
    const booking = bookingState.newBooking;
    const appType = booking.getAppoinmnetTypeID();
    if( appType ){
        
        const params = {
            AppointmentTypeID:   appType,
            StartTime:           start,
            FinishTime:          end
        };
        params.PartyID = partyID?? 0;

        params.VisualCall = booking?.isVisual?? false;
        
        api.transact('HoldSlot', params )
        .then( r => r.apiResult )
        .then( r => bookingUpdater( B_ACTIONS.TIME_HELD_EVENT, r ) )
        .catch( err => getTypesAndContinue() );
    }else{
        getTypesAndContinue();
    }
}


export                  {bookingInProgress, rescheduleInProgress, bookingActive
                         , BS_STATES, B_ACTIONS, personCalendarClick}
export default           useBookingState

